import React, { useEffect } from "react";
import Layout from "./components/Layout";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import Index from "./pages/DashboardPage";
import ImportLeadPage from "./pages/ImportLeadPage";
import LeadListPage from "./pages/LeadListPage";
import ArchiveLeadPage from "./pages/ArchiveLeadPage";
import PipelineLeadPage from "./pages/PipelineLeadPage";
import LeadStatusPage from "./pages/LeadStatusPage";
import BusinessTypePage from "./pages/BusinessTypePage";
import NetworksPage from "./pages/NetworksPage";
import SaleTypePage from "./pages/SaleTypePage";
import HeadSetPage from "./pages/HeadSetPage";
import TarrifPage from "./pages/TarrifPage";
import CreateLeadPage from "./pages/CreateLeadPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import ForgotPage from "./pages/ForgotPage";
import UsersPage from "./pages/UsersPage";
import RolesPage from "./pages/RolesPage";
import CreateRolePage from "./pages/CreateRolePage";
import ImportClientPage from "./pages/ImportClientPage";
import ClientListPage from "./pages/ClientListPage";
import PipelineClientPage from "./pages/PipelineClientPage";
import TrainingPage from "./pages/TrainingPage";
import OrdersPage from "./pages/OrdersPage";
import NewCampaignPage from "./pages/NewCampaignPage";
import CampaignListPage from "./pages/CampaignListPage";
import CompaignPage from "./pages/CompaignPage";
import CampaignTemplatePage from "./pages/CampaignTemplatePage";
import ChatPage from "./pages/ChatPage";
import Group from "./components/Group/Group";
import Profile from "./components/Group/Profile";
import Notes from "./components/Group/Notes";
import Invoice from "./components/Group/Invoice";
import Tasks from "./components/Group/Tasks";
import Group2 from "./components/Group/Group2";
import ClientStatusPage from "./pages/ClientStatusPage";
import ActivityPage from "./pages/ActivityPage";
import ActivityLogsPage from "./pages/ActivityLogsPage";
import Campaign from "./components/Group/Campaign";
import Documents from "./components/Group/Documents";
import Logs from "./components/Group/Logs";
import Order from "./components/Group/Order";
import NewOrder from "./pages/OrdersPage/NewOrder";
import CreateOrder from "./components/Group/Order/CreateOrder";
import ProfilePage from "./pages/ProfilePage";
import OrderStatusPage from "./pages/OrderStatusPage";
import VerifyPage from "./pages/VerifyPage";
import ResetPage from "./pages/ResetPage";

// Current Routes
import AlertsPage from "./pages/AlertsPage";
import ExpensePage from "./pages/ExpensePage";
import AccountManagerPage from "./pages/AcccountManagerPage";
import TicketTypePage from "./pages/TicketTypePage";
import TicketStatusPage from "./pages/TicketStatusPage";

import LeaguesPage from "./pages/LeaguesPage";
import IdentifiesListPage from "./pages/IdentitiesPage";
import CreateIdentifyPage from "./pages/IdentitiesPage/Create";
import EditIdentifyPage from "./pages/IdentitiesPage/Edit";
import TasksPage from "./pages/TasksPage";
import NotesPage from "./pages/NotesPage";
import DocumentsPage from "./pages/DocumentsPage";
import CalendarsPage from "./pages/CalendarPage";
import EditRolePage from "./pages/EditRolePage";
import TeamsPage from "./pages/TeamsPage";
import TicketsPage from "./pages/TicketsPage";
import CreateTicketPage from "./pages/TicketsPage/CreateTicketPage";
import EditTicketPage from "./pages/TicketsPage/EditTicketPage";
import EditLeadPage from "./pages/EditLeadPage";

// New Routes
import ViewApplication from "./pages/ViewAppication";
import CreateApplication from "./pages/ViewAppication/create";
import EditApplication from "./pages/ViewAppication/edit";
import DriversPage from "./pages/Drivers";
import DriverManagementPage from "./pages/DriverManagementPage";
import ThankYou from "./pages/ThankyouPage";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";

import JobsPage from "./pages/JobsPage";
import ViewDrivers from "./pages/Drivers/ViewDrivers";

import EditDriverDetails from "./pages/DriverManagementPage/edit";
import HistoryPage from "./pages/HistoryPage";
import DriversAddModal from "./pages/DriverManagementPage/AddModal";
import EditDriverApplication from "./pages/DriverManagementPage/EditDriverApplication";
import DriverManagementArchivePage from "./pages/DriverManagementPage/archive";

import PaymentsPage from "./pages/PaymentsPage";
import CompaniesPage from "./pages/CompaniesPage";
import BrokersPage from "./pages/Brokers";
import FactoringCompaniesPage from "./pages/FactoringCompaniesPage";
import Jobs from "./pages/Jobs";
import CompletedJobs from "./pages/Jobs/CompletedJobs";
import JobsView from "./pages/Jobs/View";
import EmailTemplatePage from "./pages/EmailTemplate";
import InvoicePage from "./pages/Invoice";
import PermitsPage from "./pages/PermitsPage";
import { messaging, onMessageListener, requestForToken } from "./firebase";
import { onMessage } from "firebase/messaging";
import Assets from "./pages/Assets";
import AdminsPage from "./pages/AdminsPage";
import DispatchersPage from "./pages/DispatchersPage";
import DriverStatement from "./pages/DriverStatement";
import SubscriptionManagementPage from "./pages/SubscriptionManagementPage";
// import AddJob from "./pages/Jobs/AddJob_";
import IftaCompliance from "./pages/IftaCompliance/IftaCompliance";
import IftaComplianceView from "./pages/IftaCompliance/IftaComplianceView";
import IftaPublicUrl from "./pages/IftaCompliance/IftaPublicUrl";
import AddJob from "./pages/Jobs/AddJob";


function App() {
  useEffect(() => {
    requestForToken();
  }, []);

  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        console.log("Set Notification", {
          title: payload.notification.title,
          body: payload.notification.body,
        });
      })
      .catch((err) => console.log("failed: ", err));
  }, []);

  useEffect(() => {
    // Listen for incoming messages while the app is in the foreground
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Message received in foreground:", payload);
    });

    // Clean up the listener when the component unmounts
    return () => {
      unsubscribe();
    };
  }, []); // Run this effect only once on component mount

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/application/view/:systemID/:driverId"
            element={<ViewApplication />}
          />
          <Route path="/application/create" element={<CreateApplication />} />
          <Route
            path="/application/edit/:systemID/:driverId"
            element={<EditApplication />}
          />
          <Route path="/ifta-public-url/:id" element={<IftaPublicUrl />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route
            path="/sign-in"
            element={<PublicRoute component={SignInPage} />}
          />
          <Route
            path="/sign-up"
            element={<PublicRoute component={SignUpPage} />}
          />
          <Route
            path="/forgot-password"
            element={<PublicRoute component={ForgotPage} />}
          />
          <Route
            path="/verify-otp"
            element={<PublicRoute component={VerifyPage} />}
          />
          <Route
            path="/reset-password"
            element={<PublicRoute component={ResetPage} />}
          />
          <Route path="/invoice/:id" element={<InvoicePage />} />

          <Route path="/" element={<PrivateRoute component={Layout} />}>
            <Route index element={<Index />} />

            <Route path="/profile" element={<ProfilePage />} />

            <Route
              path="lead"
              element={
                <>
                  <Outlet />
                </>
              }
            >
              <Route path="import" element={<ImportLeadPage />} />
              <Route path="create" element={<CreateLeadPage />} />
              <Route path="edit" element={<EditLeadPage />} />
              <Route path="list" element={<LeadListPage />} />
              <Route path="archive" element={<ArchiveLeadPage />} />
              <Route path="pipeline" element={<PipelineLeadPage />} />
              <Route path="group" element={<Group />}>
                <Route path="profile" element={<Profile />} />
                <Route path="notes" element={<Notes />} />
                <Route path="invoice" element={<Invoice />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="campaign" element={<Campaign />} />
                <Route path="documents" element={<Documents />} />
                <Route path="logs" element={<Logs />} />
                <Route path="order" element={<Order />} />
              </Route>
              <Route path="new-order" element={<CreateOrder />} />
            </Route>

            <Route
              path="client"
              element={
                <>
                  <Outlet />
                </>
              }
            >
              <Route path="import" element={<ImportClientPage />} />
              <Route path="create" element={<CreateLeadPage />} />
              <Route path="list" element={<ClientListPage />} />
              <Route path="pipeline" element={<PipelineClientPage />} />
              <Route path="group" element={<Group2 />}>
                <Route path="profile" element={<Profile />} />
                <Route path="notes" element={<Notes />} />
                <Route path="invoice" element={<Invoice />} />
                <Route path="tasks" element={<Tasks />} />
                <Route path="campaign" element={<Campaign />} />
                <Route path="documents" element={<Documents />} />
                <Route path="logs" element={<Logs />} />
                <Route path="order" element={<Order />} />
              </Route>
              <Route path="new-order" element={<CreateOrder />} />
            </Route>

            <Route path="/permits" element={<PermitsPage />} />

            <Route
              path="marketing"
              element={
                <>
                  <Outlet />
                </>
              }
            >
              <Route path="new-campaign" element={<NewCampaignPage />} />
              <Route path="campaign-list" element={<CampaignListPage />} />

              <Route path="activity-list" element={<ActivityPage />} />
              <Route
                path="campaign-template"
                element={<CampaignTemplatePage />}
              />
            </Route>

            <Route path="/chat" element={<ChatPage />} />

            <Route path="/training" element={<TrainingPage />} />

            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/new-order" element={<NewOrder />} />
            <Route path="alerts" element={<AlertsPage />} />

            <Route path="/activity-logs" element={<ActivityLogsPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/drivers" element={<DriversPage />} />
            <Route path="/driver/add" element={<DriversAddModal />} />
            <Route path="/driver/edit/:id" element={<DriversAddModal />} />
            <Route path="/drivers/view/:id" element={<ViewDrivers />} />
            <Route
              path="/driver-aaplication/edit/:id"
              element={<EditDriverApplication />}
            />
            <Route
              path="/drivers-management/edit"
              element={<EditDriverDetails />}
            />
            <Route path="/jobs" element={<JobsPage />} />

            <Route
              path="/drivers-management"
              element={<DriverManagementPage />}
            />
            <Route
              path="/drivers-management/archive"
              element={<DriverManagementArchivePage />}
            />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/expense" element={<ExpensePage />} />
            <Route path="/payments" element={<PaymentsPage />} />

            {/* new pages */}
            <Route path="driver-statement" element={<DriverStatement />} />
            <Route
              path="/subscription-and-billing-management"
              element={<SubscriptionManagementPage />}
            />

            <Route path="/brokers" element={<BrokersPage />} />
            <Route
              path="/factoring-company"
              element={<FactoringCompaniesPage />}
            />
            <Route path="/job" element={<Jobs />} />
            <Route path="/add-jobs" element={<AddJob />} />
            {/* <Route path="/add-jobs" element={<AddJob />} /> */}
            <Route path="/completed-jobs" element={<CompletedJobs />} />
            <Route path="/job-view/:id" element={<JobsView />} />
            <Route path="/email-template" element={<EmailTemplatePage />} />

            <Route path="/assets" element={<Assets />} />
            <Route path="/admins" element={<AdminsPage />} />
            <Route path="/dispatchers" element={<DispatchersPage />} />

            <Route path="/users" element={<UsersPage />} />
            <Route path="/roles" element={<RolesPage />} />
            <Route path="/create-role" element={<CreateRolePage />} />
            <Route path="/edit-role" element={<EditRolePage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/create-ticket" element={<CreateTicketPage />} />
            <Route path="/edit-ticket" element={<EditTicketPage />} />

            <Route path="/ifta-compliance" element={<IftaCompliance />} />


            <Route path="/ifta-compliance-view/:id" element={<IftaComplianceView />} />
            <Route
              path="setting"
              element={
                <>
                  <Outlet />
                </>
              }
            >
              <Route path="lead-status" element={<LeadStatusPage />} />
              <Route path="client-status" element={<ClientStatusPage />} />
              <Route path="order-status" element={<OrderStatusPage />} />
              <Route path="compaigns" element={<CompaignPage />} />
              <Route path="business-type" element={<BusinessTypePage />} />
              <Route path="networks" element={<NetworksPage />} />
              <Route path="sale-type" element={<SaleTypePage />} />
              <Route path="head-set" element={<HeadSetPage />} />
              <Route path="tarrif" element={<TarrifPage />} />

              {/* <Route path="tagging" element={<TaggingPage />} /> */}

              <Route path="account-manager" element={<AccountManagerPage />} />
              <Route path="ticket-page" element={<TicketTypePage />} />
              <Route path="ticket-status" element={<TicketStatusPage />} />
              <Route path="leagues" element={<LeaguesPage />} />
            </Route>
            <Route
              path="identifies"
              element={
                <>
                  <Outlet />
                </>
              }
            >
              <Route path="list" element={<IdentifiesListPage />} />
              <Route path="create" element={<CreateIdentifyPage />} />
              <Route path="edit" element={<EditIdentifyPage />} />
            </Route>
            <Route path="tasks" element={<TasksPage />} />

            <Route path="notes" element={<NotesPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="calendar" element={<CalendarsPage />} />
            <Route path="calendar" element={<CalendarsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
